import { DayPicker } from 'react-day-picker';
import { he } from 'date-fns/locale';
import 'react-day-picker/dist/style.css';
import { toISO, fromISO, today } from '../utils/period';

// The arbitrary-day-range half of PeriodPicker: a react-day-picker calendar
// plus two manual date inputs.
//
// This file exists as its own module for one reason beyond tidiness: it is the
// ONLY import site of react-day-picker in the app. react-day-picker pulls in
// date-fns, which is ESM, and CRA's Jest transform has to be told to compile it
// (see the `jest` key in client/package.json). Keeping the dependency behind a
// single module means every other part of the date filter — the month grid,
// presets, labels, the mobile pill — can be unit-tested behind one
// `jest.mock('./DayRangeView', …)` regardless of how that transform behaves.
//
// `dir="rtl"` and `weekStartsOn={0}` (Sunday) are both required for Israel and
// are not defaults — do not drop them.
export default function DayRangeView({ dateFrom, dateTo, onChange }) {
  const selected = (dateFrom || dateTo)
    ? { from: fromISO(dateFrom), to: fromISO(dateTo) }
    : undefined;

  return (
    <>
      <DayPicker
        mode="range"
        dir="rtl"
        locale={he}
        weekStartsOn={0}
        numberOfMonths={1}
        selected={selected}
        onSelect={(r) => onChange(r?.from ? toISO(r.from) : '', r?.to ? toISO(r.to) : '')}
        defaultMonth={fromISO(dateFrom) || fromISO(dateTo) || today()}
      />
      <div className="docs-filter-dateinputs">
        <label>
          <span>מ-</span>
          <input
            type="date"
            value={dateFrom || ''}
            onChange={(e) => onChange(e.target.value, dateTo)}
          />
        </label>
        <label>
          <span>עד</span>
          <input
            type="date"
            value={dateTo || ''}
            onChange={(e) => onChange(dateFrom, e.target.value)}
          />
        </label>
      </div>
    </>
  );
}
